<script>

	export let data;
	export let trends;
	export let state;
	export let subject;
	export let options;
	export let charts;
	export let onLoad = data.find(x => x.id === state);

	let heading = onLoad.name;

	let ranking = onLoad.ranking;
	let value = trends[onLoad.state][subject]
	let subjectString = options.find(x => x.id === subject).label;

	let svgDesktop;
	let svgMobile;

	const years = {
		lesen: '2011',
		rechtschreibung: '2016',
		mathematik: '2011',
		zuhoeren: '2011',
	}

	export function update(subj, state) {
		const set = data.find(x => x.id === state);
		
		heading = set.name;
		subject = subj;
		subjectString = options.find(x => x.id === subj).label;
		value = trends[set.state][subj];
		ranking = set['ranking'];

		svgDesktop.innerHTML = prepareSVG(charts[state], 'desktop');
		svgMobile.innerHTML = prepareSVG(charts[state], 'mobile');
		console.log()
		//svgDesktop.childNodes[0].style.opacity = 0;
	}	

	function prepareSVG(svg, type){

		svg = decodeURIComponent(svg).replace('data:image/svg+xml,', '');
		
		if (type === 'mobile') {
			svg = svg.replace("width='220'", "width='170'")
			svg = svg.replace("height='165'", "height='129'")
			svg = svg.replace("<svg", "<svg preserveAspectRatio='xMinYMin meet' vvv")
			svg = svg.replace("vvv", "viewBox='0 0 220 129'")
		} else if (type === 'desktop') {
			svg = svg.replace("width='220'", "width='228'")
			svg = svg.replace("height='165'", "height='166'")
			svg = svg.replace("<svg", "<svg preserveAspectRatio='xMinYMin meet' vvv")
			svg = svg.replace("vvv", "viewBox='0 0 228 166'")
		}
		
		options.forEach((o) => {
			if (o.value !== subject) {
				svg = svg.replaceAll('class=\'' + o.value + '\'', 'style="opacity: 0.2"')
			} else {
				svg = svg.replaceAll('opacity=\'0.5\'', 'opacity=\'0.9\'')
			}
		})
		return svg;
	}

	const merger = {
		'rechtschreibung': 'in',
		'lesen': 'im', 
		'mathematik': 'in',
		'zuhoeren': 'im'
	} 
</script>

<div class="infobox">
	
	<div class="heading">
		<h3>{heading}</h3>
		{#if state != 'mv'}
		<div class="ranking {subject}">{ranking[subject]}. Platz {merger[subject]} {subjectString}</div>
		{:else}
	<div class="annotation">Keine Daten für 2021 vorhanden</div>
	{/if}
	</div>
	<div class="chart">
		<div class="desktop" bind:this={svgDesktop}>{@html prepareSVG(charts[state], 'desktop')}</div>
		<div class="mobile" bind:this={svgMobile}>{@html prepareSVG(charts[state], 'mobile')}</div>
	</div>

	
	{#if state != 'mv'}
	<div class="value">
		<div class="desktop">
			Veränderung seit {years[subject]}: <span class="{subject}">{value}%</span>
		</div>
		<div class="mobile">
			<span class="badge {subject}">{value}%</span> <span>seit {years[subject]}</span>
		</div>
	</div>
	{/if}


</div>

<style lang="scss">
	@import "../main.scss";

	.infobox {
		margin-left: 10px;
		box-sizing: border-box;
		width: 260px;
		flex-grow: 1;
		flex-shrink: 0;
		padding: 12px;
		align-self: baseline;
		margin-top: 68px;
		box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.15);
		border-radius: 5px;
		min-height: 281px;

		&::after {
			display: none;
		}

		@media (max-width: $breakpoint-tablet-s) {
			min-height: 171px;
			max-height: 171px;
			width: 343px;
			max-width: 100%;
			align-self: center;
			margin-top: 10px;
			display: grid;
			grid-template-columns: 1fr 185px;
			grid-auto-rows: minmax(72px, auto);
			box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.15);
			margin-left: 0;
		}

		@media (max-width: $breakpoint-mobile-l) {
			grid-template-columns: 1fr 180px;
		}

		@media (max-width: $breakpoint-mobile-s) {
			grid-template-columns: 1fr 168px;
		}

		.heading {
			grid-column: 1;
			grid-row: 1;
			overflow: hidden;


			h3 {
				margin: 0;
				font-size: 17px;
				line-height: 24px;
				font-weight: 600;
				max-width: 100%;

				@media (max-width: $breakpoint-tablet-s) {
					font-size: 16px;
					line-height: 20px;
				}
			}
	
			.ranking {
				font-size: 15px;
				line-height: 15px;
				font-weight: 600;
				margin-bottom: 10px;

				@media (max-width: $breakpoint-tablet-s) {
					font-size: 14px;
					line-height: 16px;
				}
			}
		}


		.chart {
			padding: 6px;
			grid-column: 2;
			grid-row: 1/3;

			.mobile {
				display: none;
			}

			@media (max-width: $breakpoint-tablet-s) {
				max-width: 185px;
				border-left: 1px solid rgba(152,152,152,0.3);

				.desktop {
					display: none;
				}

				.mobile {
					display: block;
				}
			}
		}

		.value {
			text-align: right;
			font-size: 14px;
			line-height: 24px;
			color: #909090;
			font-weight: 500;
			grid-column: 1;
			grid-row: 2;
			align-self: end;
			margin-right: 27px;

			.mobile {
				display: none;
			}

			@media (max-width: $breakpoint-tablet-s) {
				margin-right: 0;

				.mobile {
					display: block;
					text-align: left;
				}

				.desktop {
					display: none;
				}
			}

			span {
				font-weight: 600;
			}

			.badge {
				border-radius: 2px;
				padding: 1px 3px 1px 3px;
				width: 50%;

				&.rechtschreibung {
					background-color: $rechtschreibungAlpha;
				}

				&.mathematik {
					background-color: $mathematikAlpha;
				}

				&.zuhoeren {
					background-color: $zuhoerenAlpha;
				}

				&.lesen {
					background-color: $lesenAlpha;
				}

				+ span {
					display: inline-block;
				}
			}

			
		}
	}

	.rechtschreibung {
		color: $rechtschreibung;
	}

	.mathematik {
		color: $mathematik;
	}

	.zuhoeren {
		color: $zuhoeren;
	}

	.lesen {
		color: $lesen;
	}

	.annotation {
		color: #8f8f8f;
		font-size: 15px;
		line-height: 15px;
		font-weight: 600;
		margin-bottom: 10px;

		@media (max-width: $breakpoint-tablet-s) {
			font-size: 13px;
			line-height: 16px;
		}
	}

	@keyframes fadein {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
	svg {
		animation: fadein ease .5s;
		animation-iteration-count: 1;
		animation-fill-mode: forwards;
	}
</style>
